import { useCallback, useState } from 'react';
import { getSkillDataFromColumnId } from '../components/StudentsSkillsTable/tableConfig';
export var useExternalSorting = function () {
    var _a = useState(null), sortData = _a[0], setSortData = _a[1];
    var onSortChange = useCallback(function (params) {
        if (!params) {
            setSortData(null);
            return;
        }
        var name = getSkillDataFromColumnId(params.columnId)[0];
        setSortData({ name: name, direction: params.sort });
    }, []);
    var onSortRemove = useCallback(function () {
        setSortData(null);
    }, [setSortData]);
    return {
        sortData: sortData,
        onSortChange: onSortChange,
        onSortRemove: onSortRemove,
    };
};
